<template>
    <div class="experiment-page">
    <h1>Лабораторные работы по физике</h1>

<ExperimentCard
      title="Законы Ньютона"
      description="Симуляция законов Ньютона"
      link="/законы-ньютона"
    />
    <ExperimentCard
      title="Маятник"
      description="Движение маятника"
      link="/движение-маятника"
    />
    <ExperimentCard
      title="Оптический эксперимент"
      description="Исследование оптических свойств линз"
      link="/оптический-эксперимент"
    />
    <ExperimentCard
      title="Построение изображения в линзе"
      description="Описание про линзы"
      link="/построение-изображения-в-линзе"
    />
    <ExperimentCard
      title="Изучение законов термодинамики"
      description="Изучение термодинамических процессов, таких как расширение газа, изменение температуры и давления"
      link="/закон-термодинамики"
    />
    <ExperimentCard
      title="Столкновение двух тел"
      description="Изучить закон сохранения импульса при упругом и неупругом столкновении."
      link="/Столкновение-двух-тел"
    />
    <ExperimentCard
      title="Электрическая схема"
      description="Изучение электрических цепей и их компонентов."
      link="/электрическая-схема"
    />

    <ExperimentCard
      title="Движение заряда в электрическом поле"
      description="Симуляция электростатического поля точечных зарядов. Линии напряжённости, векторы поля и траектория тестового заряда."
      link="/движение-заряда-в-поле"
    />

    <ExperimentCard
      title="Катящийся цилиндр"
      description="Симуляция движения тела по наклонной плоскости: чистое качение, скольжение, распределение энергии, момент инерции."
      link="/катящийся-цилиндр"
    />

    <ExperimentCard
      title="Маятник Ардуино"
      description="Подключение Arduino к компьютеру и получение данных о положении маятника в реальном времени."
      link="/маятник-ардуино"
    />

    <ExperimentCard
      title="График движения маятника"
      description="Отображение данных движения маятника в виде графика."
      link="/маятник-график"
    />

    <ExperimentCard
      title="Физический пазл"
      description="Изучение физических явлений с помощью пазла."
      link="/физический-пазл"
    />

    <ExperimentCard
      title="Симуляция Бюффона для вычисления числа π"
      description="Симуляция Бюффона для вычисления числа π"
      link="/число-пи"
    />

    
    </div>
</template>

<script>
import ExperimentCard from "@/components/ExperimentCard.vue";

export default {
  components: {
    ExperimentCard,
  },
};
</script>


<style scoped>
h1 {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}
.experiment-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
</style>